import React from "react";
import { useSeo } from "../lib/useSeo";
import Layout from "../components/Layout";
import FounderBlock from "../components/FounderBlock";
import { Youtube, Instagram, Mail, MapPin } from "lucide-react";
import { BRAND, SOCIAL, MAILTO, EMAIL_LABEL } from "../lib/brand";

export default function About() {
  useSeo({ title: "About Us", description: "Rapid24News — Fast, Trusted, Fearless. Lucknow's daily news desk, Uttar Pradesh news network, national & investigative digital media portal led by Shivam Dubey." });
  return (
    <Layout>
      <div className="bg-r24-black text-white">
        <div className="max-w-4xl mx-auto px-4 py-14 text-center">
          <img src="/brand/logo.jpg" alt="Rapid24News" className="h-20 w-20 rounded-full object-cover ring-2 ring-r24-red mx-auto mb-5" />
          <h1 className="font-head font-bold text-4xl md:text-6xl">RAPID<span className="text-r24-red">24</span>NEWS</h1>
          <p className="uc tracking-[0.3em] text-gray-400 font-semibold mt-3">Fast • Trusted • Fearless</p>
        </div>
      </div>

      <section className="max-w-3xl mx-auto px-4 py-12">
        <h2 className="font-head font-bold text-3xl uc mb-5 border-b-2 border-r24-red pb-2 inline-block">Who We Are</h2>
        <div className="article-body text-gray-800">
          <p>Rapid24News is a professional Indian digital news organization delivering fast, trusted and fearless journalism. We give special daily priority to <strong>Lucknow</strong> and <strong>Uttar Pradesh</strong>, while providing credible coverage of India and important international developments.</p>
          <p>Our focus areas include Lucknow Police & Commissionerate, district administration, LDA, Nagar Nigam, traffic, courts, crime, government, education, jobs, business, public issues and major developments across every district of Uttar Pradesh — alongside national politics, economy, technology, sports and entertainment.</p>
          <p>We follow responsible editorial practices. For crime, corruption and allegations, we clearly distinguish between an <em>allegation</em>, a <em>police claim</em>, an <em>FIR</em>, an <em>investigation</em>, a <em>court proceeding</em> and a <em>confirmed fact</em>. We never present an allegation as an established fact, and we provide corrections where needed.</p>
        </div>

        <div className="grid grid-cols-3 gap-4 my-10 text-center">
          {[["Lucknow", "Priority #1"], ["Uttar Pradesh", "Priority #2"], ["India & World", "Full Coverage"]].map(([t, s]) => (
            <div key={t} className="border-2 border-black p-4">
              <div className="font-head font-bold text-lg uc">{t}</div>
              <div className="text-xs text-r24-red font-semibold uc mt-1">{s}</div>
            </div>
          ))}
        </div>

        <div className="border-t border-gray-200 pt-8" data-testid="about-contact">
          <h3 className="font-head font-bold text-xl uc mb-4">Official Contact</h3>
          <div className="flex flex-col gap-3">
            <a href={MAILTO} aria-label={EMAIL_LABEL} data-testid="about-email" className="flex items-center gap-2 font-semibold text-r24-red hover:underline"><Mail size={18} /> {BRAND.email}</a>
            <div className="flex items-center gap-2 font-semibold"><MapPin size={18} /> {BRAND.location}</div>
            <div className="flex gap-3 mt-2">
              <a href={SOCIAL.youtube.url} target="_blank" rel="noopener noreferrer" aria-label={SOCIAL.youtube.label} data-testid="about-youtube" className="flex items-center gap-2 border-2 border-black px-4 py-2 font-semibold hover:bg-black hover:text-white transition-colors"><Youtube size={18} /> YouTube</a>
              <a href={SOCIAL.instagram.url} target="_blank" rel="noopener noreferrer" aria-label={SOCIAL.instagram.label} data-testid="about-instagram" className="flex items-center gap-2 border-2 border-black px-4 py-2 font-semibold hover:bg-black hover:text-white transition-colors"><Instagram size={18} /> Instagram</a>
            </div>
          </div>
        </div>
      </section>

      <FounderBlock />
    </Layout>
  );
}
